import { Injectable } from '@angular/core';
import { SurveyService } from 'src/app/shared/services/survey.service';

@Injectable({
  providedIn: 'root'
})
export class PortalSurveyService extends SurveyService {
  public get navigationPath(): string {
    return `portal/forms/survey/${this.secureLinkId}`;
  }
}
